// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");
var React = require("react");
var IOUtils = require("../../../shared/src/IOUtils.bs.js");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var BrowserStyle = require("../BrowserStyle.bs.js");
var Relude_Option = require("relude/src/Relude_Option.bs.js");

function image(image$1) {
  return Curry._1(BrowserStyle.style, {
              hd: BrowserStyle.height(BrowserStyle.Point.toRem(Curry._1(BrowserStyle.Box.toHeight, BrowserStyle.$$Image.toBoxSize(image$1)))),
              tl: {
                hd: BrowserStyle.width(BrowserStyle.Point.toRem(Curry._1(BrowserStyle.Box.toWidth, BrowserStyle.$$Image.toBoxSize(image$1)))),
                tl: /* [] */0
              }
            });
}

var Styles = {
  image: image
};

var make = React.forwardRef(function (Props, ref_) {
      var className = Props.className;
      var image$1 = Props.image;
      var onMouseEnter = Props.onMouseEnter;
      var onMouseLeave = Props.onMouseLeave;
      var testId = Props.testId;
      var tmp = {
        className: BrowserStyle.Utils.extendBaseStyle(image(image$1), className)
      };
      var tmp$1 = Relude_Option.map((function (prim) {
              return prim;
            }), (ref_ == null) ? undefined : Caml_option.some(ref_));
      if (tmp$1 !== undefined) {
        tmp.ref = Caml_option.valFromOption(tmp$1);
      }
      var tmp$2 = Relude_Option.map((function (fn, param) {
              return IOUtils.unsafeRunHandledAsync(fn);
            }), onMouseEnter);
      if (tmp$2 !== undefined) {
        tmp.onMouseEnter = Caml_option.valFromOption(tmp$2);
      }
      var tmp$3 = Relude_Option.map((function (fn, param) {
              return IOUtils.unsafeRunHandledAsync(fn);
            }), onMouseLeave);
      if (tmp$3 !== undefined) {
        tmp.onMouseLeave = Caml_option.valFromOption(tmp$3);
      }
      var tmp$4 = {
        children: React.createElement("div", tmp, BrowserStyle.$$Image.toElement(image$1))
      };
      if (testId !== undefined) {
        tmp$4.id = Caml_option.valFromOption(testId);
      }
      return React.createElement(ReactUtils.WithTestId.make, tmp$4);
    });

exports.Styles = Styles;
exports.make = make;
/* make Not a pure module */
